import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import grid_state_helpers, {GridState, initialGridState} from "../../../libs/grid_state_reducers";
import {Tables} from "../../../apitypes";

export type FilterItem = "product" | "user" | "workOrder" | "operation" | "machine" | "worker" | "partner"

export type RegFilters = {
    startTime: string | null;
    endTime: string | null;
    partner: Tables<"partner">[];
    product: Tables<"product">[];
    operation: Tables<"workTask">[];
    ftx: string;
    worker: Tables<"worker">[];
    machine: Tables<"machine">[];
    workOrder: Tables<"workOrder">[];
    user: Tables<"profile">[];

}

const startDate = new Date()
startDate.setHours(0, 0, 0);
const initialState: GridState & RegFilters = {
    ...initialGridState,
    sort: [{field: "StartTime", sort: "desc"}],
    ftx: "",
    startTime: startDate.toISOString(),
    endTime: null,
    product: [],
    partner: [],
    operation: [],
    machine: [],
    worker: [],
    workOrder: [],
    user: [],
};

const slice = createSlice({
    name: "reg",
    initialState,
    reducers: {
        ...grid_state_helpers,


        setFtx: (state, action: PayloadAction<string>) => {
            state.ftx = action.payload
        },
        setOperation: (state, action: PayloadAction<Tables<"workTask">[]>) => {
            state.operation = action.payload
        },
        setWorker: (state, action: PayloadAction<Tables<"worker">[]>) => {
            state.worker = action.payload
        },
        setWorkOrder: (state, action: PayloadAction<Tables<"workOrder">[]>) => {
            state.workOrder = action.payload
        },
        setPartner: (state, action: PayloadAction<Tables<"partner">[]>) => {
            state.partner = action.payload
        },
        setUser: (state, action: PayloadAction<Tables<"profile">[]>) => {
            state.user = action.payload
        },
        setMachine: (state, action: PayloadAction<Tables<"machine">[]>) => {
            state.machine = action.payload
        },
        setProduct: (state, action: PayloadAction<Tables<"product">[]>) => {
            state.product = action.payload
        },
        setStartTime: (state, action: PayloadAction<string | null>) => {
            state.startTime = action.payload
        },
        setEndTime: (state, action: PayloadAction<string | null>) => {
            state.endTime = action.payload
        },
        resetSearch: (state) => {
            return {...initialState, columns: state.columns, seq: state.seq + 1}
        }
    }
});

export const {
    setFilter,
    setSort,
    setPaginationModel,
    setFtx,
    setOperation,
    setPartner,
    setProduct,
    setWorkOrder,
    setMachine,
    setUser,
    setWorker,
    resetSearch,
    setColumns,
    setStartTime,
    setEndTime,
    setDensity
} = slice.actions
export const reducer = slice.reducer;
